(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["takt-mobile-refine"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('takt-mobile-refine')) {
    customElements.define('takt-mobile-refine', class extends HTMLElement {
      connectedCallback() {
        if(this.events)return;
        this.events=new AbortController();
        this.cleanups=[];
        this.main=this.closest('main');
        this.mobile=matchMedia('(max-width:749px)');
        const options={signal:this.events.signal};
        this.refresh=()=>{
          this.cleanups.splice(0).forEach(fn=>fn());
          if(!this.mobile.matches||!this.main)return;
          if(this.hasAttribute('data-colours')){
            this.main.querySelectorAll('.takt-wr__items').forEach(items=>{
              const cards=[...items.children].filter(e=>e.classList.contains('takt-wr__item'));
              if(!cards.length)return;
              const track=document.createElement('div');track.className='tr7-track';
              items.insertBefore(track,cards[0]);cards.forEach(card=>track.append(card));
              const dispose=this.setupSlider(track,cards);
              this.cleanups.push(()=>{dispose();cards.forEach(card=>items.insertBefore(card,track));track.remove()});
            });
          }
          if(this.hasAttribute('data-styles')){
            this.main.querySelectorAll('.takt-sg__items').forEach(track=>{
              this.cleanups.push(this.setupSlider(track,[...track.children].filter(e=>e.classList.contains('takt-sg__item'))));
            });
          }
        };
        this.mobile.addEventListener('change',this.refresh,options);
        document.addEventListener('shopify:section:load',this.refresh,options);
        document.addEventListener('shopify:section:unload',()=>{queueMicrotask(()=>this.isConnected&&this.refresh())},options);
        this.refresh();
      }
      setupSlider(track,slides) {
        if(!slides.length)return()=>{};
        const events=new AbortController(),options={signal:events.signal};
        const original={id:track.getAttribute('id'),role:track.getAttribute('role'),label:track.getAttribute('aria-label'),tabindex:track.getAttribute('tabindex')};
        const controls=this.querySelector('template').content.firstElementChild.cloneNode(true);
        track.after(controls);
        const section=track.closest('.shopify-section');
        const id=(section?.id||'TaktRefine')+'-mobile-track';
        track.id=id;track.setAttribute('role','region');track.setAttribute('aria-label',this.dataset.galleryLabel);track.setAttribute('tabindex','0');
        const prev=controls.querySelector('[data-prev]'),next=controls.querySelector('[data-next]'),position=controls.querySelector('[data-position]');
        prev.setAttribute('aria-controls',id);next.setAttribute('aria-controls',id);
        let index=0,frame;
        const update=()=>{
          const start=track.getBoundingClientRect().left+parseFloat(getComputedStyle(track).paddingLeft);
          const offsets=slides.map(slide=>Math.abs(slide.getBoundingClientRect().left-start));
          index=offsets.indexOf(Math.min(...offsets));
          position.textContent=(index+1)+' / '+slides.length;prev.disabled=index===0;next.disabled=index===slides.length-1;
        };
        const go=(target,instant=false)=>{
          const slide=slides[Math.max(0,Math.min(target,slides.length-1))];
          const left=slide.getBoundingClientRect().left-track.getBoundingClientRect().left+track.scrollLeft-parseFloat(getComputedStyle(track).paddingLeft);
          track.scrollTo({left,behavior:instant||matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
        };
        prev.addEventListener('click',()=>go(index-1),options);next.addEventListener('click',()=>go(index+1),options);
        track.addEventListener('scroll',()=>{cancelAnimationFrame(frame);frame=requestAnimationFrame(update)},options);
        track.addEventListener('keydown',e=>{if(e.target!==track||!['ArrowLeft','ArrowRight'].includes(e.key))return;e.preventDefault();go(index+(e.key==='ArrowRight'?1:-1))},options);
        track.addEventListener('shopify:block:select',e=>{const selected=slides.findIndex(slide=>slide===e.target||slide.contains(e.target));if(selected>=0)go(selected,true)},options);
        go(0,true);
        const observer=new ResizeObserver(()=>{go(index,true);update()});observer.observe(track);update();
        return()=>{
          events.abort();observer.disconnect();cancelAnimationFrame(frame);controls.remove();
          for(const [attribute,value]of Object.entries({id:original.id,role:original.role,'aria-label':original.label,tabindex:original.tabindex})){
            if(value===null)track.removeAttribute(attribute);else track.setAttribute(attribute,value);
          }
        };
      }
      disconnectedCallback(){this.events?.abort();this.events=null;this.cleanups?.splice(0).forEach(fn=>fn())}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["takt-product-details"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('takt-detail-gallery')) {
    customElements.define('takt-detail-gallery', class extends HTMLElement {
      connectedCallback() {
        this.events = new AbortController();
        this.track = this.querySelector('[data-track]');
        this.slides = [...this.querySelectorAll('[data-slide]')];
        this.index = 0;
        const options = {signal:this.events.signal};
        this.querySelector('[data-controls]').hidden = this.slides.length < 2;
        this.querySelectorAll('[data-step]').forEach(button => button.addEventListener('click', () => this.go(Number(button.dataset.step)), options));
        this.track.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault();
            this.go(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, options);
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.sync());
        }, options);
        this.addEventListener('shopify:block:select', event => {
          const slide = this.slides.find(item => item.dataset.blockId === event.detail.blockId);
          if(slide) this.track.scrollTo({left:slide.offsetLeft-this.slides[0].offsetLeft,behavior:'instant'});
        }, options);
        this.resizeObserver = new ResizeObserver(() => this.sync());
        this.resizeObserver.observe(this.track);
        this.sync();
      }
      sync() {
        if (!this.slides.length) return;
        const position = this.track.getBoundingClientRect().left;
        let nearest = 0;
        this.slides.forEach((slide,i) => {
          if(Math.abs(slide.getBoundingClientRect().left-position) < Math.abs(this.slides[nearest].getBoundingClientRect().left-position)) nearest=i;
        });
        this.index = nearest;
        this.querySelector('[data-count]').textContent = String(nearest+1).padStart(2,'0')+' / '+String(this.slides.length).padStart(2,'0');
        this.querySelector('[data-step="-1"]').disabled=nearest===0;
        this.querySelector('[data-step="1"]').disabled=nearest===this.slides.length-1;
      }
      go(step) {
        if(!this.slides.length) return;
        const next = Math.max(0,Math.min(this.slides.length-1,this.index+step));
        const left=this.slides[next].offsetLeft-this.slides[0].offsetLeft;
        this.track.scrollTo({left,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
      }
      disconnectedCallback() {
        this.events?.abort();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
